function Why() {
  return (
    <section className="w-full h-fit flex flex-col justify-center items-center gap-8 mb-4 p-12 lg:p-16">
      <h1 className="text-center text-2xl font-bold">Why AttnQ?</h1>
      <p className="text-center leading-8">
        AttnQ connects property brokers and investors by matching exact budgets
        and needs. Close the deal faster with serious, relevant leads. It cuts
        through noise and connects with serious, high-intent property buyers —
        not random leads. Buyers enter their exact budget and dream property
        specs, and AttnQ prioritizes and queues them for you based on relevance
        and conversion potential. You get a clear, ranked list of prospects
        ready to be contacted, without chasing cold inquiries.
        <br />
        It’s built to{" "}
        <span className="bg-yellow-200 p-1 border-b-3 border-b-[#dc9209]">
          save
        </span>{" "}
        time and{" "}
        <span className="bg-yellow-200 p-1 border-b-3 border-b-[#dc9209]">
          boost
        </span>{" "}
        closures.
      </p>
    </section>
  );
}

export default Why;
